import React, { useState } from 'react';
import { Alert, Button, Typography, Box } from '@mui/material';
import StepActions from './StepActions';
import { onboardingApi } from '../api';

// Open link: when someone else is filling the application, the banking and ACH steps belong to the business owner, who
// completes them on a private page. The filler sees who the owner is and can send the link now (it also goes on submit).
export default function OwnerBankingNotice({ view, onNext, onBack, part = 'settlement' }) {
  const [sent, setSent] = useState(''); const [error, setError] = useState(''); const [busy, setBusy] = useState(false);
  const owner = view.owner || {}; const done = view.ownerBanking && view.ownerBanking.status === 'complete';
  const send = async () => { setBusy(true); setError(''); try { await onboardingApi.app.sendToOwner(); setSent(owner.email); } catch (e) { setError(e.message || 'The link could not be sent.'); } finally { setBusy(false); } };
  return (<>
    <Alert severity={done ? 'success' : 'info'} sx={{ mb: 2 }}>
      <Typography sx={{ fontWeight: 600 }}>{done ? 'The business owner has completed the banking.' : 'The business owner will complete this'}</Typography>
      {!done && <Typography variant="body2">{part === 'settlement' ? 'The settlement bank accounts come' : 'The voided check or bank letter and the ACH signature come'} from {owner.name || 'the owner'}{owner.email ? ` (${owner.email})` : ''} on their own private page. The link goes out when you submit, or now.</Typography>}
    </Alert>
    {!done && <Box sx={{ mb: 1 }}>
      <Button variant="outlined" disabled={busy || !owner.email} onClick={send}>Send to owner now</Button>
      {!owner.email && <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>Add the owner's email on the Business step first.</Typography>}
      {sent && <Typography variant="body2" sx={{ mt: 1 }}>Sent to {sent}</Typography>}
      {error && <Alert severity="error" sx={{ mt: 1 }}>{error}</Alert>}
    </Box>}
    <StepActions onBack={onBack} onNext={onNext} />
  </>);
}
